import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem } from './../../styles';
import StyledFormGridColumn from './components/form-grid-column/form-grid-column.styles';
var StyledFormGrid = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e13bj6q60"
} : {
  target: "e13bj6q60",
  label: "StyledFormGrid"
})(function (_ref) {
  var collapsedH = _ref.collapsedH,
    collapsedV = _ref.collapsedV;
  return /*#__PURE__*/css("align-items:end;display:grid;grid-template-columns:repeat(12, minmax(0, 1fr));grid-template-rows:repeat(2, auto);", !collapsedH && /*#__PURE__*/css("column-gap:", rem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledFormGrid;")), " ", !collapsedV && /*#__PURE__*/css(StyledFormGridColumn, "{margin:", rem(8, 0), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledFormGrid;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledFormGrid;"));
});
export default StyledFormGrid;